import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../UI/Button';
import { useTranslation } from 'react-i18next';
import { getLanguagePathPrefix } from '../../i18n';

export const RestoCTA: React.FC = () => {
  const { t } = useTranslation(['common', 'resto']);
  
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background Image - Remplacé par Pexels */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/1126728/pexels-photo-1126728.jpeg?auto=compress&cs=tinysrgb&w=1920')`
        }}
      />
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/50 dark:bg-black/60" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
            {t('resto:cta.title')}
          </h2>
          <p className="text-xl md:text-2xl font-semibold text-yellow-400 mb-4 italic">
            {t('resto:cta.slogan')}
          </p>
          <p className="text-lg text-white/90 mb-8 leading-relaxed">
            {t('resto:cta.subtitle')}
          </p>
          
          {/* Features list */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10 max-w-xl mx-auto">
            <div className="flex items-center justify-center space-x-3">
              <CheckCircle className="h-6 w-6 text-green-400 flex-shrink-0" />
              <span className="text-white/90">{t('common:cta.features.freeTrial')}</span>
            </div>
            <div className="flex items-center justify-center space-x-3">
              <CheckCircle className="h-6 w-6 text-green-400 flex-shrink-0" />
              <span className="text-white/90">{t('common:cta.features.support')}</span>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="glossy" size="lg" className="text-lg px-8 py-4 rounded-full" onClick={() => { 
              window.location.href = `${getLanguagePathPrefix()}/resto/pricing/?product=prod_SeK3reIBRC1RyE`;
            }}>
              <span>{t('common:cta.freeTrial')}</span>
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="text-lg px-8 py-4 text-white border-white hover:bg-white/10"
              onClick={() => { 
                window.location.href = `${getLanguagePathPrefix()}/contact`;
              }}
            >
              {t('common:cta.viewDemo')}
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
